module.exports = __webpack_public_path__ + "static/img/13.4ab8cc5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/3/sp/13.png
// module id = Fxsh
// module chunks = 0